import React from 'react'
import { WebsiteThemeListColorsInterface } from 'src/shared/types/website-settings-types'
import { twMerge } from 'tailwind-merge'
import { ColorCircle } from 'src/editor/shared/ui-lib/color-circle'

interface ColorsPreviewProps {
  colors: WebsiteThemeListColorsInterface
  className?: string
}

export const ColorsPreview = ({ colors, className }: ColorsPreviewProps) => {
  return (
    <div className={twMerge('flex gap-[2px]', className)}>
      {Object.entries(colors).map(el => (
        <ColorCircle key={el[0]} color={el[1]} />
      ))}
    </div>
  )
}
